import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import t from '../../lib/I18n';
import _ from 'lodash';
import Icon from '../general/Icon';
import BaseModal from '../general/BaseModal';
import Loading from '../../components/general/Loading';
import NotifyBy from '../../components/account/NotifyBy';
import User from '../../records/User';
import PropTypes from 'prop-types';
import PushNotificationActions from '../../actions/PushNotificationActions';
import DelayRepayActions from '../../actions/DelayRepayActions';
import TrackingActions from "../../actions/TrackingActions";
import { notificationPreferences } from '../../constants/AppConstants';
import DisruptionAlertService from '../../services/DisruptionAlertService';


const NotificationPreferences = ({
    user,
    preferenceCentre,
    isDDM,
    isOCDR,
    notificationPreferencesModalOpen,
    hideSummary,
    defaultNotificationPreference,
    disableCloseWithoutChoosingPreference,
    onContinueAction,
}) => {
    const [isNotificationPreferencesModalOpen, setIsNotificationPreferencesModalOpen] = useState(notificationPreferencesModalOpen);
    const [notifyByPreference, setNotifyByPreference] = useState(defaultNotificationPreference);
    const [notifyByPreferenceNew, setNotifyByPreferenceNew] = useState(null);
    const [hasPushNotifications, setHasPushNotifications] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const closeModal = (prefChosen) => {
        if (disableCloseWithoutChoosingPreference && !prefChosen) {
            return false;
        }
        setNotifyByPreferenceNew(null);
        setIsNotificationPreferencesModalOpen(false);

        if (onContinueAction) {
            onContinueAction();
        }

        return true;
    };

    const handleContinue = async () => {
        const chosenPreference = notifyByPreferenceNew || defaultNotificationPreference;

        if (chosenPreference) {
            setIsSaving(true);

            if (isOCDR) {
              await DelayRepayActions.subscribe(user, chosenPreference);
              TrackingActions.amendNotificationPreference();
            } else {

              let chosenPreferences = null;

              if (chosenPreference === notificationPreferences.APP_AND_EMAIL) {
                chosenPreferences = {"isEmailNotification": true, "isCloudMessageNotification": true };
              } else if (chosenPreference === notificationPreferences.APP) {
                chosenPreferences = {"isEmailNotification": false, "isCloudMessageNotification": true };
              } else {
                chosenPreferences = {"isEmailNotification": true, "isCloudMessageNotification": false };
              }

              await DisruptionAlertService.setPreferences(user.id, chosenPreferences);
            }

            setIsSaving(false);
        }
        closeModal(true);
    };

    const customer = user && user.customer || {};
    let autoDelayRepayApp, autoDelayRepayEmail;
    if (customer && customer.preferences) {
        autoDelayRepayApp = customer.preferences.autoDelayRepayApp;
        autoDelayRepayEmail = customer.preferences.autoDelayRepayEmail;
    }

    useEffect(() => {
        async function fetchUserPushNotificationPreferences() {
            const preferences = await PushNotificationActions.getPreference(user);
            if (preferences) {
                setHasPushNotifications(preferences.length > 0);
            }
        }

        async function fetchUserDDMPreferences() {
          const preferences = await DisruptionAlertService.getPreferences(user.id);
          const { isEmailNotification, isCloudMessageNotification } = preferences;

          if (isEmailNotification && isCloudMessageNotification) {
              setNotifyByPreference(notificationPreferences.APP_AND_EMAIL);
          } else if (isEmailNotification) {
              setNotifyByPreference(notificationPreferences.EMAIL);
          } else if (isCloudMessageNotification) {
              setNotifyByPreference(notificationPreferences.APP);
          }
        }

        if (user && user.customer) {
            _.defer(() => fetchUserPushNotificationPreferences());
            if (isDDM) {
              _.defer(() => fetchUserDDMPreferences());
            }
        }

       if (isOCDR) {
        if (autoDelayRepayApp && autoDelayRepayEmail) {
            setNotifyByPreference(notificationPreferences.APP_AND_EMAIL);
        } else if (autoDelayRepayApp) {
            setNotifyByPreference(notificationPreferences.APP);
        } else if (autoDelayRepayEmail) {
            setNotifyByPreference(notificationPreferences.EMAIL);
        }
       }
    }, [autoDelayRepayApp, autoDelayRepayEmail, user, isDDM, isOCDR, notifyByPreferenceNew]);

    let notifyByPreferenceText = null;

    if (notifyByPreference === notificationPreferences.APP_AND_EMAIL) {
        notifyByPreferenceText = 'app and email';
    } else if (notifyByPreference === notificationPreferences.APP) {
        notifyByPreferenceText = 'app';
    } else if (notifyByPreference === notificationPreferences.EMAIL) {
        notifyByPreferenceText = 'email';
    }

    return (
        <div className={hideSummary ? "" : "border--bottom"}>
            {!hideSummary && (<React.Fragment>
              <div className="preference-centre-subscribe__text">
                  {notifyByPreference ? <p>
                      {t('preference-centre.subscribe.preference.text', { notifyByPreferenceText })}
                      {(notifyByPreference === notificationPreferences.APP_AND_EMAIL || notifyByPreference === notificationPreferences.EMAIL) &&
                          t('preference-centre.subscribe.preference.to', { userEmail: user.email })
                      }
                  </p> : <p>{t('preference-centre.subscribe.preference.noPrefSet')}</p>}
              </div>
              <Button
                  bsStyle="link"
                  className="adr-edit-address-btn margin-bottom--sm"
                  onClick={() => setIsNotificationPreferencesModalOpen(true)}
              >
                  <Icon className="adr-edit-address-btn-icon" icon="pen" />
                  {t(
                      preferenceCentre
                          ? 'preference-centre.subscribe.preference.edit.button'
                          : 'notification-settings.edit.button',
                  )}
              </Button>
            </React.Fragment>)}
            {isNotificationPreferencesModalOpen && (
                <BaseModal
                    className="modal--med"
                    show={isNotificationPreferencesModalOpen}
                    onClose={() => closeModal()}
                    disableContinue={false}
                    disableClose={disableCloseWithoutChoosingPreference}
                    onContinue={handleContinue}
                    closeText="auto-dr.subscribe.modal-close"
                    titleText="auto-dr.account.notifications.modal.title"
                    continueText="Confirm"
                >
                    <section className="text-left">
                        {isSaving ? <Loading
                            message={t('preference-centre.subscribe.preference.updating')}
                            unwrapped
                            standalone
                        /> : <NotifyBy
                            notifyByPreference={notifyByPreferenceNew || notifyByPreference}
                            setNotifyByPreference={setNotifyByPreferenceNew}
                            hasPushNotifications={hasPushNotifications}
                            isDDM={isDDM}
                            isOCDR={isOCDR}
                            isJourneyAlerts
                        />}
                    </section>
                </BaseModal>
            )}
        </div>
    );
};

NotificationPreferences.propTypes = {
    user: PropTypes.instanceOf(User),
    preferenceCentre: PropTypes.bool,
    isDDM: PropTypes.bool,
    isOCDR: PropTypes.bool,
    notificationPreferencesModalOpen: PropTypes.bool,
    hideSummary: PropTypes.bool,
    defaultNotificationPreference: PropTypes.string,
    disableCloseWithoutChoosingPreference: PropTypes.bool,
    onContinueAction: PropTypes.func,
};

export default NotificationPreferences;
